<template>
  <div class="module">
      <div class="content">
        <div class="top">
          <span class="top-label">移宇医院管理系统</span>
        </div>
        <div class="middle">
          <div class="middle-img">
              <img src="../../assets/logo.png" height="44px" width="170px" >
          </div>
          <div class="middle-account">
              <div class="middle-account-icon">
                  <img src="../../assets/icon_user.png" >
              </div>
              <input type="text" class="middle-account-input" placeholder="账号" v-model="formInline.account">
          </div>
          <div class="middle-password">
              <div class="middle-password-icon">
                  <img src="../../assets/icon_password.png" >
              </div>
              <input type="password" class="middle-password-input" placeholder="密码" v-model="formInline.password">
          </div>
          <div class="middle-btn">
              <button class="btn" @click="handleSubmit">登录</button>
          </div>
        </div>
      </div>
      <div class="bottom">
          <div v-html="'联系我们 |&nbsp隐私政策&nbsp|&nbsp服务协议&nbsp|&nbsp@2021&nbsp上海移宇科技股份有限公司&nbsp版权所有'">
          </div>
          <div v-html="'沪ICP备08D13753号-3&nbsp&nbsp&nbsp沪公网安备31011502014155号'">
          </div>
      </div>
  </div>
</template>

<script>
import messageCal from '../../assets/js/message'
export default {
  name: 'login',
  data () {
    return {
      formInline: {
        account: '',
        password: '',
        role: 'admin'
      }
    }
  },
  methods: {
    handleSubmit () {
      let val = {
        username: this.formInline.account,
        password: this.formInline.password,
        role: this.formInline.role
      }
      if (this.formInline.account === '') {
        this.$message.error('请输入账号')
        return
      }
      if (this.formInline.password === '') {
        this.$message.error('请输入密码')
        return
      }
      this.$http.withCredentials = true
      this.$http.post('/api/v2.1/admin/login', val).then(res => {
        if (res.status === 200) {
          let datas = res.data.error
          if (datas === 0) {
            sessionStorage.setItem('username', val.username)
            sessionStorage.setItem('password', val.password)
            sessionStorage.setItem('role',res.data.role)
            this.$router.push('/home')
          } else if (datas === 9) {
            this.$message.error('密码错误,剩余尝试次数' + res.data.left_try_num + '次')
          } else if (datas === 62) {
            let time = new Date(parseInt(res.data.unlock_time) * 1000).toLocaleString()
            this.$message.error('账号已锁定,解锁时间' + time)
          } else {
            this.$message.error(messageCal[datas])
          }
        } else {
          console.log('no')
        }
      })
    }
  },
  created () {
    let that = this
    document.onkeydown = function (e) {
      e = window.event || e
      if (that.$route.path === '/login' && (e.code === 'Enter' || e.code === 'enter')) { // 验证在登录界面和按得键是回车键enter
        that.handleSubmit() // 登录函数
      }
    }
  }
}
</script>

<style scoped>
.module {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    background-color:#0c544f;
    padding: 0px;
    min-height: 100vh;
    margin: 0;

}
.content {
    display: flex;
    flex: 1;
    flex-flow: column;
    justify-content: center;
    align-items: center;

}
.top {
    flex: 0 0 100%;
    height: 36px;
    /* margin-top: 356px; */
}
.top-label {
    /* width:338px; */
    height:36px;
    font-family:Source Han Sans CN;
    color:#ffffff;
    font-size:36px;
    letter-spacing:10px;
    line-height:36px;
    text-align:center;
}
.middle {
    max-width: 440px;
    width: 100%;
    height: 276px;
    flex-flow: column;
    background-color:#ffffff;
    border-radius:8px;
    margin-top: 10px;
    padding-top:14px ;
}
.middle-img {
    max-width:270px;
    height:44px;
}
.middle-account {
    height: 35px;
    width: 80%;
    margin-top: 27px;
    border-bottom: 1px solid #0c544f;
    display: flex;
    flex-flow: row;
    margin-left: 49px;
    justify-content: flex-start;
    align-items: center;
}
.middle-account-icon, .middle-password-icon {
    display: flex;
    width:30px;
    height:30px;
    justify-content: flex-start;
    align-items: center;
}
.middle-account-input, .middle-password-input {
    width: 60%;
    height:24px;
    margin-left: 12px;
    border: none;
    line-height: 24px;
    font-size: 16px;
}
.middle-account-input:focus {
    outline:none
}
.middle-password {
    height: 35px;
    width: 80%;
    margin-top: 11px;
    border-bottom: 1px solid #0c544f;
    display: flex;
    flex-flow: row;
    margin-left: 49px;
    justify-content: flex-start;
    align-items: center;
}
.middle-password-input:focus {
    outline:none
}
.middle-btn {
    width:150px;
    height:30px;
    background-color:#0c544f;
    border-radius:30px;
    margin-top: 50px;
    margin-left: 145px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    
}
.btn {
    /* width:72px; */
    height:24px;
    color:#ffffff;
    font-size:18px;
    background-color:#0c544f;
    text-align:center;
    letter-spacing:1px;
    border: 0px;
}
.bottom {
    /* width:600px; */
    display: flex;
    flex-flow: column;
    flex: 0;
    align-items: center;
    color:#ffffff;
    font-size:16px;
    line-height:24px;
    text-align:center;
    margin-bottom: 79px;
    letter-spacing:1px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue